import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import { Navigate, useNavigate } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader, Button } from "semantic-ui-react";
import { TableAlumnos } from "../../../components/Alumnos/TableAlumnos/TableAlumnos";
import { ToastContainer, toast } from "react-toastify";
import ExcelJS from "exceljs"; // Importa la librería ExcelJS
import { saveAs } from "file-saver";

function AlumnosEgresados() {
  const { auth } = useAuth();
  if (!auth?.me?.es_personal_control_escolar) {
    return <Navigate to={"/"}></Navigate>;
  }
  return <LogicaAlumnosEgresados />;
}

function LogicaAlumnosEgresados() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [refetch, setRefetch] = useState(false);
  const [alumnosE, setAlumnosE] = useState(null);
  const [loading, setLoading] = useState(true);

  async function getAlumnos() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_API}/api/alumno/?estado_alumno=Egresado`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const result = response.data;
      setLoading(false);
      setAlumnosE(result);

      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getAlumnos();

    // eslint-disable-next-line
  }, [refetch]);

  const generateExcel = async () => {
    try {
      const excelTemplateResponse = await axios.get(
        `${BASE_API}/api/alumno-data-template/`, // Endpoint para obtener el archivo de plantilla de Excel
        {
          responseType: "arraybuffer", // Cambia la responseType a arraybuffer para recibir un array de bytes
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const excelData = excelTemplateResponse.data;

      // Crear un nuevo libro de Excel
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(excelData);

      // Obtener la hoja de trabajo
      const worksheet = workbook.getWorksheet("Sheet1");

      // Obtener el estilo de la fila 3
      const templateRow = worksheet.getRow(3);

      // Definir las claves de los atributos del alumno y los índices de las celdas
      const attributeKeys = [
        "matricula",
        "semestre",
        "alumno_traslado",
        "apellido_paterno",
        "apellido_materno",
        "nombre",
        "fecha_nacimiento",
        "curp",
        "edad",
        "sexo",
        "nacionalidad",
        "lugar_nacimiento",
        "calle_domicilio",
        "numero_domicilio",
        "colonia_domicilio",
        "municipio_domicilio",
        "estado_domicilio",
        "codigo_postal_domicilio",
        "telefono_casa",
        "telefono_celular",
        "email",
        "tipo_sanguineo",
        "discapacidad",
        "descripcion_discapacidad",
        "lengua_indigena",
        "descripcion_lengua_indigena",
        "planel_procedencia",
        "clave_plantelProc",
        "promedio_plantel_procedencia",
        "servicio_medico",
        "num_afiliacion",
        "trabajo_activo",
        "descripcion_trabajo",
        "dependencia_economica",
        "descripcion_dependencia",
        "apellido_paterno_tutor",
        "apellido_materno_tutor",
        "nombre_tutor",
        "calle_domicilio_tutor",
        "numero_domicilio_tutor",
        "colonia_domicilio_tutor",
        "municipio_domicilio_tutor",
        "estado_domicilio_tutor",
        "codigo_postal_domicilio_tutor",
        "telefono_casa_tutor",
        "telefono_celular_tutor",
        "email_tutor",
        "fecha_baja_temporal_1",
        "fecha_baja_temporal_2",
        "fecha_baja_definitiva",
      ];

      // Desplazar filas hacia abajo para hacer espacio para nuevas filas de alumnos
      const numAlumnos = alumnosE.length;
      worksheet.spliceRows(4, 1, ...Array(numAlumnos).fill([]));

      // Modificar las celdas según sea necesario usando alumnosE
      let rowIndex = 3; // Comenzar en la fila 3
      alumnosE.forEach((alumno) => {
        const row = worksheet.getRow(rowIndex);
        attributeKeys.forEach((key, index) => {
          const cell = row.getCell(index + 1);
          if (key === "alumno_traslado") {
            cell.value = alumno[key] ? "Sí" : "No"; // Asignar "Sí" o "No" según el valor booleano
          } else {
            cell.value = alumno[key] || " ";
          }
          cell.style = templateRow.getCell(index + 1).style; // Copiar el estilo de la celda
        });

        rowIndex++; // Avanzar a la siguiente fila para el siguiente alumno
      });

      // Guardar el libro de Excel
      const excelBuffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([excelBuffer]), `Alumnos_egresados.xlsx`);
    } catch (error) {
      console.error("Error al generar el archivo Excel:", error);
      toast.error("Error al generar el archivo Excel");
    }
  };

  const updateAlumno = async (data) => {
    navigate("/AlumnosEgresados/DatosAlumnoEgresado", {
      state: { datosAlumno: data },
    });
  };

  return (
    <>
      <h1 className="tituloin">LISTA DE EGRESADOS</h1>

      {loading ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <TableAlumnos alumnos={alumnosE} updateAlumno={updateAlumno} />
      )}
      {alumnosE?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "12px",
          }}
        >
          <Button
            icon="file excel"
            content="Descargar datos"
            className="descarga"
            onClick={generateExcel}
          />
        </div>
      )}
      <ToastContainer />
    </>
  );
}

export default AlumnosEgresados;
